<template>
    <div :class="classes">
        <carousel @navigation-click-forward="onPaginationClick" v-model="page" :adjustableHeight="true" :per-page=1 :navigation-enabled="true" :pagination-enabled=false navigation-next-label="<div></div>" navigation-prev-label="<div></div>">
            <slot></slot>
        </carousel>
        <div class="number" v-if="!hideNumber">
            <h1>{{pad2(page+1)}}</h1>
            <span>{{pad2(max)}}</span>
            <div class="line"></div>
        </div>
        <!-- vcarousel :data="slides"/ -->
    </div>
</template>

<script>
import strpad from 'strpad'

export default {
  name: 'CarouselOne',
  props: {
    max: {
      type: Number,
      default: 5
    },
    pagination: {
      type: String,
      default: ''
    },
    hideNumber: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      page: 0,
      slides: [
        '<div class="example-slide">Slide 1</div>',
        '<div class="example-slide">Slide 2</div>',
        '<div class="example-slide">Slide 3</div>'
      ]
    }
  },
  computed: {
    classes: function () {
      return 'carousel-one ' + this.pagination
    }
  },
  methods: {
    pad2: function (n) {
      return strpad.left(n, 2, '0')
    },
    onPaginationClick: function (event) {
    }
  }
}
</script>
<style>
    .example-slide {
        align-items: center;
        background-color: #666;
        color: #999;
        display: flex;
        font-size: 1.5rem;
        justify-content: center;
        min-height: 10rem;
    }
</style>



// WEBPACK FOOTER //
// src/front/components/widgets/common/CarouselOne.vue